import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";
import useOptions from "../../hooks/useOptions";
import { ClaimType } from "../common/RenderIf";

type Props = {
    optionType: string,
    claimType: ClaimType
    isRecordChecked: (claimType: ClaimType, value: string) => boolean
    updateRecordClaim: (recordId: string, claimType: ClaimType, status: boolean) => void
}

const RecordPermissions = ({ optionType, isRecordChecked, updateRecordClaim, claimType }: Props) => {
    const { options } = useOptions(optionType);
    const theme = useTheme();

    if (!options) return null;

    return (<TableContainer sx={{ maxHeight: '30vh', height: '30vh', mt: 10 }}>
        <Table size='small' sx={{ width: '100%' }} stickyHeader>
            <TableHead>
                <TableRow>
                    <TableCell colSpan={2}>
                        Authorised To
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {options.map((options, customerIndex: number) => {
                    return (
                        <TableRow key={customerIndex} sx={{ '& .MuiTableCell-root:first-of-type': { pl: 0 } }}>
                            <TableCell sx={{ fontWeight: 600, color: theme => `${theme.palette.text.primary} !important` }} >
                                {options.name}
                            </TableCell>
                            <TableCell sx={{ textAlign: 'left', width: 0, whiteSpace: 'nowrap' }}>
                                <Checkbox size='small' checked={isRecordChecked(claimType, options.value)} onChange={(e) => updateRecordClaim(options.value, claimType, e.target.checked)} style={{ width: 1, whiteSpace: 'nowrap' }} />
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    </TableContainer>)
}
export default RecordPermissions;